<template>
    <div class="main">
        <title-component :title="title"></title-component>
        <popular-product-component :bizCode="bizCode"></popular-product-component>
        <progress-product-component :bizCode="bizCode"></progress-product-component>
        <abnormal-product-component :bizCode="bizCode"></abnormal-product-component>
        <product-analysis-component :bizCode="bizCode"></product-analysis-component>
        <tc-component v-if="showTc" :bizCode="bizCode" :productId="productId" :productName="productName" :startDateParams="startDate" :endDateParams="endDate"></tc-component>
    </div>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
    }
</style>

<script>
    import TitleComponent from '../components/title/Title.vue'
    import PopularProductComponent from './components/popular-product/PopularProduct.vue'
    import ProgressProductComponent from './components/progress-product/ProgressProduct.vue'
    import AbnormalProductComponent from './components/abnormal-product/AbnormalProduct.vue'
    import ProductAnalysisComponent from './components/product-analysis/ProductAnalysis.vue'
    import TcComponent from './components/tc/Tc.vue'
    import { eventBus } from 'helpers/index'

    export default {
        components: {
            TitleComponent,
	        PopularProductComponent,
	        ProgressProductComponent,
	        AbnormalProductComponent,
	        ProductAnalysisComponent,
	        TcComponent
        },
        data () {
            const data = {
                title: '商品数据',
                showTc: false,   // 是否显示弹层
	            bizCode: null, // 业务线
	            productId: 0,
	            productName: '',
                startDate: '',
                endDate: ''
            }
	        switch (this.$route.params.type||this.$route.meta.type) {
		        case 'gty': data.bizCode = 11021;
			        break;
		        case 'jiujing': data.bizCode = 11022;
			        break;
		        default: window.location.href = '/'
	        }
	        return data;
        },
        methods: {
        	// 改变弹层显示状态
	        changeShowTc (status) {
	        	this.showTc = status;
            }
        },
        created () {
	        eventBus.$on('showTc', params => {
	        	this.productId = params.productId;
	        	this.productName = params.productName;
	        	this.startDate = params.startDate;
	        	this.endDate = params.endDate;
		        this.changeShowTc(true);
            })

	        eventBus.$on('closeTc', () => {
		        this.changeShowTc(false);
	        })
        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?4e9d88c8